import { NotFoundState } from "@rio-cloud/rio-uikit";
import { useMediaQuery } from "@mui/material";

const EmptyData = () => {

    const isMobile = useMediaQuery("(max-width: 768px)");
    if (isMobile) {
        return (
            <div className="w-full flex justify-center items-center p-4">
                <NotFoundState
                    headline="Ops! Nenhum chamado encontrado"
                    message='Por favor, refaça sua pesquisa ou crie um novo chamado.'
                    outerClassName="border-none w-full"
                />
            </div>
        );
    }
    return (
        <table className="margin-top-10 w-full">
            <tbody>
                <tr>
                    <td colSpan={5}>
                        <NotFoundState
                            headline="Ops! Nenhum chamado encontrado"
                            message='Por favor, refaça sua pesquisa ou crie um novo chamado.'
                            outerClassName="border-none"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default EmptyData;
